<template>
  <div class="wizard-footer d-flex justify-space-between align-center pa-4">
    <v-btn
      v-if="isFirstStep"
      size="x-large"
      text
      @click="$emit('cancel')"
    >
      キャンセル
    </v-btn>
    <v-btn
      v-else
      size="x-large"
      text
      @click="$emit('prev')"
    >
      戻る
    </v-btn>

    <v-btn
      v-if="isLastStep"
      size="x-large"
      color="primary"
      :disabled="nextDisabled"
      @click="$emit('complete')"
    >
      完了
    </v-btn>
    <v-btn
      v-else
      size="x-large"
      color="primary"
      :disabled="nextDisabled"
      @click="$emit('next')"
    >
      次へ
    </v-btn>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'WizardFooter',
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    nextDisabled: { type: Boolean, default: false },
  },
  setup(props) {
    const isFirstStep = computed(() => props.currentStep === 1)
    const isLastStep = computed(() => props.currentStep === props.totalSteps)

    return { isFirstStep, isLastStep }
  },
}
</script>

<style scoped>
/* テーマ変数を使用してライト/ダークモードに追従させる */
.wizard-footer {
  background: var(--v-background-base, transparent);
  border-top: 1px solid rgba(127, 127, 127, 0.2);
}
</style>
